/*
 * File: Localizer.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Appointment component for react-big-calendar
 */

import React from "react";
import PropTypes from "prop-types";

const Appointment = ({ event }) => (
  <b>{event.blockName || event.patientName}</b>
);

Appointment.propTypes = {
  event: PropTypes.object.isRequired
};

export default Appointment;
